import { captureException } from '@sentry/react'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { isEmpty } from '../../../utils/isEmpty'

const BASE_PATH = '/partners/vendor/orders/example_csv'

export const getExampleCsv = async () => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { get } = StackAPI()
  const { id } = role

  const headers = {
    Accept: 'text/csv',
    'Content-Type': 'text/csv'
  }

  const request = {
    path: BASE_PATH,
    params: { cur_partner: `vendor-${id}` },
    headers,
    responseType: 'blob'
  }

  try {
    const response = await get(request)

    return response.data
  } catch (error) {
    captureException(error, { extra: { role } })
    return { error: 'unknown error' }
  }
}
